<template>
  <div class="gmap-info-window">
    <div
      v-if="opened"
      ref="content"
    >
      <slot />
    </div>
    <InfoWindow
      v-if="opened && contentReady"
      :options="anchoredOptions"
      @closeclick="$emit('closeclick', $event)"
    />
  </div>
</template>

<script>
import { InfoWindow } from 'vue3-google-map';

// vue3-google-map's InfoWindow only takes `options`, opens itself once the map tiles load and can
// only be closed by unmounting it. It also builds the google.maps.InfoWindow during setup, before
// its own slot ref exists, so a window mounted on demand would open empty. This wrapper restores
// the `opened` / `position` contract, renders the content itself and hands it over through
// `options.content` once the node exists. The root stays hidden: google.maps.InfoWindow moves the
// content node into the map, so nothing should ever be visible in normal document flow.
export default {
  name: 'GmapInfoWindow',
  components: { InfoWindow },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['closeclick'],
  data: () => ({ contentReady: false }),
  computed: {
    anchoredOptions() {
      return {
        ...this.options,
        position: this.position,
        content: this.contentReady ? this.$refs.content : undefined,
      };
    },
  },
  watch: {
    opened: {
      immediate: true,
      async handler(opened) {
        this.contentReady = false;

        if (!opened) {
          return;
        }

        await this.$nextTick();
        this.contentReady = this.opened && !!this.$refs.content;
      },
    },
  },
};
</script>
